import { CARD_FORM } from "../form-card-type";
import { dropdown } from "../../../dropdown";

import { populatePartnerDropdown, populateCustomerDropdown, populateCardGroupDropdown } from "./create-new-card-helpers";
import { postNewCard } from "./post-new-card";

/**
 * Handles adding a new card or cards and call all functions needed to perform the task
 * 
 * @returns void
 */
const HandleAddCard = async () => {
  populatePartnerDropdown();

  const partnerSelected = CARD_FORM.cardPartner;
  const ObserverCards = new MutationObserver((mutRecords: any) => {
    for (const { type, attributeName, target } of mutRecords) {
      if (type === 'attributes' && attributeName === 'data-value') {
        if (CARD_FORM.cardCustomer.hasAttribute('data-value')) {
          CARD_FORM.cardCustomer.removeAttribute('data-value');
          CARD_FORM.cardCardGroup.innerText = 'Please Select A Customer';
          dropdown({}, 'card-group', 'Card Group', true, true, true);
        }

        if (target.getAttribute('data-value')) {
          CARD_FORM.cardCustomer.innerText = 'Getting Customer List...';
          populateCustomerDropdown(String(partnerSelected.getAttribute('data-value')), target.textContent);
        }
      }
    }
  });

  ObserverCards.observe( partnerSelected, { attributes: true } );

  const customerSelected = CARD_FORM.cardCustomer;
  const ObserverCustomer = new MutationObserver((mutRecords: any) => {
    for (const { type, attributeName, target } of mutRecords) {
      if (type === 'attributes' && attributeName === 'data-value') {
        if (CARD_FORM.cardCardGroup.hasAttribute('data-value')) {
          CARD_FORM.cardCardGroup.removeAttribute('data-value');
        }

        if (target.getAttribute('data-value')) {
          CARD_FORM.cardCardGroup.innerText = 'Getting Card Group List...';
          populateCardGroupDropdown(String(customerSelected.getAttribute('data-value')), target.textContent);
        }
      }
    }
  });

  ObserverCustomer.observe( customerSelected, { attributes: true } );

  postNewCard();
};

export default HandleAddCard;